<template>

    <div>
        <div style="overflow-y: auto;" class="container">
            <div class="text-box">
                <span>开启状态：</span>
                <el-switch
                        v-model="privateData.status"
                        active-value="1"
                        inactive-value="0"
                        @change="statusChange"
                >
                </el-switch>
            </div>
            <div class="text-box">
                <span>城市：</span>
                <p>{{privateData.city_name}}</p>
            </div>
            <div class="text-box">
                <span>总通话分钟数：</span>
                <p class="text">{{privateData.total_num}}</p>
            </div>
            <div class="text-box">
                <span>剩余通话分钟数：</span>
                <div class="text flex">
                    <p>{{privateData.surplus}}</p>
                    <span v-if="privateData.total_num<privateData.alert_num" style="color: red;display: inline-block">(低于预警数量，请尽快充值)</span>
                    <span v-else style="color: green;display: inline-block">(充足)</span>
                </div>


            </div>


            <div class="text-box" style="margin-top: 40px">
                <span>剩余通话分钟数量预警：</span>
                <div class="text flex">
                    <p>{{privateData.alert_num}}分钟</p>
                    <el-button size="mini" style="margin-left: 20px" type="primary" @click="edit_isShow = !edit_isShow">设置</el-button>
                </div>
            </div>

            <div class="text-box" v-for="(item,index) in privateData.number">
                <span>隐私保护显示号码{{index+1}}：</span>
                <p class="text">{{item}}</p>
            </div>


            <div class="text-box" style="color: #999999;text-align: center;margin-top: 20px">
               设置隐私通话余额不足充值提醒，低于设置数量页面提示建议尽快充值以免影响使用，不设置默认1000分钟
            </div>

        </div>

        <el-row style="margin: 20px auto">
            <el-col>
                <el-col :span="12">
                    <el-card shadow="hover">
                        <div class="left">
                            <h3>隐私通话服务充值信息</h3>
                            <div class="item">
                                <p class="title">单位名称：</p>
                                <p class="item-text">{{privateData.bank_info.unit_name}}</p>
                            </div>
                            <div class="item">
                                <p class="title">开户行：</p>
                                <p class="item-text">{{privateData.bank_info.account_bank}}</p>
                            </div>
                            <div class="item">
                                <p class="title">账号：</p>
                                <p class="item-text">{{privateData.bank_info.account_number}}</p>
                            </div>
                            <div class="item">
                                <p class="title">税务代码：</p>
                                <p class="item-text">{{privateData.bank_info.tax_code}}</p>
                            </div>
                            <div class="item">
                                <p class="title">电话：</p>
                                <p class="item-text">{{privateData.bank_info.phone}}</p>
                            </div>
                            <div class="item">
                                <p class="title">地址：</p>
                                <p class="item-text">{{privateData.bank_info.address}}</p>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card shadow="hover">
                        <div>
                            <h3>收费标准</h3>
                            <p>每个隐私号码月租费用10元/月，{{privateData.privateNo.fee}}元/分钟，通话不足一分钟计费按一分钟计算</p>
                            <p>元/分钟，通话不足一分钟计费按一分钟计算</p>

                        </div>
                    </el-card>
                </el-col>
            </el-col>

        </el-row>

        <div style="overflow-y: auto;" class="container">

            <h4>通话记录</h4>

            <!-- 表格 -->
            <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">



                <el-table-column prop="telX" label="通话号码" min-width="140">
                </el-table-column>

                <el-table-column prop="billno" label="订单号" min-width="180">
                </el-table-column>

                <el-table-column prop="telB" label="客户电话" min-width="140">
                </el-table-column>

                <el-table-column prop="telA" label="司机电话" min-width="140">
                </el-table-column>

                <el-table-column prop="telX" label="通话号码" min-width="140">
                </el-table-column>

                <el-table-column prop="direction" label="呼叫方向" min-width="140">
                    <template slot-scope="scope">
                      <span>
                        {{scope.row.direction == '0'?'司机呼叫乘客':'乘客呼叫司机'}}
                      </span>
                    </template>
                </el-table-column>

                <el-table-column prop="callTime" label="开始拨打时间" min-width="140">
                </el-table-column>

                <el-table-column prop="finishTime" label="结束通话时间" min-width="140">
                </el-table-column>

                <el-table-column prop="callDuration" label="通话时长" min-width="140">
                </el-table-column>

            </el-table>
            <!-- 分页组件 -->
            <div class="pagination">
                <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
            </div>

        </div>

        <editPrivateNum :isShow="edit_isShow" :data="privateData.alert_num"
                            @onSubmit="onSubmit">
        </editPrivateNum>


    </div>

</template>

<script>

    let _this;
    import editPrivateNum from './editPrivateNum.vue'
    export default {
        components: {
            editPrivateNum,
        },
        data() {
            return {
                edit_isShow:false,

                tableData: [],
                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                },
                result_data: [],

                privateData:{}
            };
        },
        created() {
            _this = this;
           _this.getPrivateConf();
           _this.privateRecord();
        },
        methods:{
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.privateRecord();

            },
            onSubmit(){
                _this.getPrivateConf();
                _this.privateRecord();
            },
            privateRecord(){
                _this.$post(
                    '/privateno/privateRecord',
                    _this.search_data
                ).then((res) => {

                   _this.tableData = res.data;
                    _this.result_data = res;
                });
            },

            getPrivateConf(){
                _this.$post(
                    '/privateno/getPrivateConf'
                ).then((res) => {

                    _this.privateData = res.data;
                    console.log(_this.privateData);

                });
            },
            statusChange(){
                _this.$post(
                    '/privateno/changePrivateStatus',{
                        status:_this.privateData.status
                    }
                ).then((res) => {

                });
            }
        }
    };

</script>

<style scoped>
    .text-box{
        display: flex;
        width: 500px;
        margin: 10px auto;
    }
    .text-box span{
        display: block;
        width: 200px;
        text-align: right;
    }
    .text-box>p{
        width: 300px;
    }

    .text {
        font-size: 16px !important;
        font-weight: 400 !important;
        color: #ff7606 !important;

    }
    .text.flex{
        display: flex;
        justify-content: center;
    }
    .text>span{
        width: auto;
    }
    h3{
        font-size: 24px;
        margin-bottom: 20px;
    }
    .left .item{
        display: flex;
        margin: 10px auto;

    }
    .left .item .title,
    .left .item .item-text{
        font-size: 16px;
    }
    h4{
        font-size: 20px;
        margin-bottom: 10px;
    }
</style>
